import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchPreLoginSlides } from "../actions/preLoginActions";

const preLoginSlice = createSlice({
  name: "preLogin",
  initialState: {
    slides: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPreLoginSlides.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPreLoginSlides.fulfilled, (state, action) => {
        state.loading = false;

        const widget = action.payload.widgets?.find((w) => w.position === 0);
        state.slides = widget ? widget.slides : [];
      })
      .addCase(fetchPreLoginSlides.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default preLoginSlice.reducer;
